import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { MsalProvider } from '@azure/msal-react';
import { msalEnabled, msalInstance } from './authRuntime';

function renderApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  const app = (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  root.render(
    msalEnabled ? (
      <MsalProvider instance={msalInstance}>
        {app}
      </MsalProvider>
    ) : app
  );
}

// Handle redirect BEFORE rendering the app.
// This ensures the auth hash is consumed and accounts are populated
// before React ever renders AuthGuard (preventing the login redirect loop).
if (msalEnabled) {
  msalInstance.initialize().then(() => {
    return msalInstance.handleRedirectPromise();
  }).then((response) => {
    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    }
  }).catch((err) => {
    console.error('MSAL Redirect Error:', err);
  }).finally(() => {
    renderApp();
  });
} else {
  renderApp();
}
